import React from 'react';
import startCase from 'lodash/startCase';

import ProductListContainer from './ProductListContainer';
import ProductType from './ProductType';

import Skeleton from '@twicapp/ui/components/legacy/Skeleton';
import { STORE_PAGE_ELEMENTS } from 'constants/testSelectors';

const ProductListLoading = ({ product_type }: $TSFixMe) => (
  <ProductListContainer data-testid={STORE_PAGE_ELEMENTS.PRODUCT_LIST_SKELETON}>
    <ProductType>{startCase(product_type)}</ProductType>
    <Skeleton active />
    <Skeleton active />
    <Skeleton active />
  </ProductListContainer>
);

export default ProductListLoading;
